import styled, { keyframes, css } from 'styled-components';

const rotate = keyframes`
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
  `;


export const LoaderWrapper = styled.div<any>`
  height: 41px;
  width: 41px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
  svg path,
  svg rect{
    fill: var(--primary);
  }
  @media screen and (max-width: 740px) {

  }
`;
